import React, { useState } from 'react'
import { Formik } from 'formik'
import {
	FormHeader,
	FormTitle,
	InputsContainer,
	ButtonsContainer,
	LinkButton,
	FormContainer,
	Wrapper,
	FormContent,
	FormSubtitle
} from '../../../components/ui/form'
import Input from '../../../components/ui/input'
import Select from '../../../components/ui/select'
import { Button } from '../../../components/ui/button'
import { contact } from '../../../api'
import { addFlashMessage, hideLoader, showLoader } from '../../../actions'
import to from 'await-catch'
import { connect } from 'react-redux'
import { add } from 'date-fns'
import Feedback from '../../../components/feedback'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { useClinicsOptions } from '../../../hooks/useClinicsOptions'

const FormContact = ({ auth, patient, showLoader, hideLoader, addFlashMessage }) => {
	const [isSent, setIsSent] = useState({ isSent: false, isSentWithError: false })
	const history = useHistory()
	const { clinicsOptions, clinics } = useClinicsOptions({
		showLoader,
		hideLoader,
		addFlashMessage,
		useMockFallback: false
	})

	const handleFormSubmit = async values => {
		try {
			showLoader()
			const email = clinics.find(clinic => clinic.id === values.clinic)?.mail || ''
			const parsedValues = {
				nombre: `${values.name} ${values.lastname}`,
				telefono: values.phone,
				cuerpo: values.comment,
				destino: email,
				email: auth.email,
				roles: auth.roles
			}

			const [err] = await to([contact(parsedValues)])

			if (err) throw new Error('Error en el fetch de contacto')

			setIsSent({ isSent: true, isSentWithError: false })
		} catch (error) {
			setIsSent({ isSent: true, isSentWithError: true })
		} finally {
			hideLoader()
		}
	}

	const onClickButton = () => {
		history.push('/inicio')
	}
	return !isSent.isSent ? (
		<Formik
			initialValues={{
				name: auth.nombre ? auth.nombre : '',
				lastname: auth.apellido ? auth.apellido : '',
				phone: patient.telefono ? patient.telefono : '',
				clinic: '',
				comment: ''
			}}
			onSubmit={handleFormSubmit}
		>
			{({ values, handleChange, handleSubmit, setFieldValue }) => {
				const handleOnlyLettersChange = field => event => {
					const sanitizedValue = event.target.value.replace(/[^A-Za-zÀ-ÖØ-öø-ÿ\s]/g, '')
					setFieldValue(field, sanitizedValue)
				}

				return (
				<Wrapper>
					<FormContainer justifyMobile="center" align="start" margin="0 0">
						<FormHeader align="start">
							<FormTitle align={'start'}>Formulario de contacto</FormTitle>
							<FormSubtitle align='start'>Dejanos tu duda y te respondemos a la brevedad.</FormSubtitle>
						</FormHeader>
						<FormContent as="form">
							<InputsContainer>
								<Input fullWidth
									name="name"
									value={values.name}
									onChange={handleOnlyLettersChange('name')}
									label={'Nombre'}
									placeholder={'Ingresá tu nombre'}
								/>
								<Input fullWidth
									name="lastname"
									value={values.lastname}
									onChange={handleOnlyLettersChange('lastname')}
									label={'Apellido'}
									placeholder={'Ingresá tu apellido'}
								/>
								<Input fullWidth
									name="phone"
									value={values.phone}
									onChange={handleChange}
									label={'Teléfono'}
									placeholder={'Ingresá tu teléfono'}
								/>
								<Select
									label={'Clínica / Centro médico'}
									name="clinic"
									value={values.clinic}
									onChange={e => setFieldValue('clinic', e.target.value)}
									options={clinicsOptions}
									placeholder={'Seleccioná una clínica'}
								/>
								<Input
									fullWidth
									height={140}
									label="Comentario"
									name="comment"
									value={values.comment}
									onChange={handleChange}
									placeholder="Escribí tu comentario"
									isTextArea
								/>
							</InputsContainer>
							<ButtonsContainer>
								<Button
									label={'Enviar consulta'}
									$variant="primary"
									size="mobile"
									type="submit"
									onClick={handleSubmit}
								/>
							</ButtonsContainer>
						</FormContent>
					</FormContainer>
				</Wrapper>
				)
			}}
		</Formik>
	) : (
		<Feedback
			title={!isSent.isSentWithError ? "Enviamos tu consulta" : "Hubo un error al enviar tu consulta"}
			bodyText={!isSent.isSentWithError ? "En breve vamos nos vamos a estar comunicando con vos" : "Por favor volvé a intentarlo más tarde"}
			buttonLabel="Volver al inicio"
			secondaryButtonLabel="Enviar otra consulta"
			onClickButton={onClickButton}
			isError={isSent.isSentWithError}
			onClickSecondaryButton={() => setIsSent({ isSent: false, isSentWithError: false })}
		/>
	)
}

const mapDispatchToProps = {
	showLoader,
	hideLoader,
	addFlashMessage
}

const mapStateToProps = ({ auth, patient }) => {
	return { auth, patient }
}

export default connect(mapStateToProps, mapDispatchToProps)(FormContact)